import { useQuery } from 'react-query'

import { getCommentsHistory } from '../api/getCommentsHistory'

interface IUseCommentsHistory {
  externalId: string
  externalEntityInfo: string
}

export function useCommentsHistory({
  externalId,
  externalEntityInfo,
}: IUseCommentsHistory) {
  return useQuery({
    queryFn: () => getCommentsHistory({ externalId, externalEntityInfo }),
    queryKey: ['comments-history', externalId, externalEntityInfo],
  })
}
